import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ServerIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.2 7.2H7.208M7.2 16.8H7.208M6.56 10.4H17.44C18.336 10.4 18.784 10.4 19.126 10.226C19.427 10.072 19.672 9.827 19.826 9.526C20 9.184 20 8.736 20 7.84V6.56C20 5.664 20 5.216 19.826 4.874C19.672 4.573 19.427 4.328 19.126 4.174C18.784 4 18.336 4 17.44 4H6.56C5.664 4 5.216 4 4.874 4.174C4.573 4.328 4.328 4.573 4.174 4.874C4 5.216 4 5.664 4 6.56V7.84C4 8.736 4 9.184 4.174 9.526C4.328 9.827 4.573 10.072 4.874 10.226C5.216 10.4 5.664 10.4 6.56 10.4ZM6.56 20H17.44C18.336 20 18.784 20 19.126 19.826C19.427 19.672 19.672 19.427 19.826 19.126C20 18.784 20 18.336 20 17.44V16.16C20 15.264 20 14.816 19.826 14.474C19.672 14.173 19.427 13.928 19.126 13.774C18.784 13.6 18.336 13.6 17.44 13.6H6.56C5.664 13.6 5.216 13.6 4.874 13.774C4.573 13.928 4.328 14.173 4.174 14.474C4 14.816 4 15.264 4 16.16V17.44C4 18.336 4 18.784 4.174 19.126C4.328 19.427 4.573 19.672 4.874 19.826C5.216 20 5.664 20 6.56 20Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ServerIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ServerIcon);
